import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_SELLER_ADJUSTMENTS_ACTION_TYPE } from '../actions';

const initialState = [];

const loanSellerAdjustmentsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      // possibly this redux property is not used anymore, only the api call (action)
      case LOAN_SELLER_ADJUSTMENTS_ACTION_TYPE.EDIT_SELLER_ADJUSTMENTS:
        return payload?.sellerAdjustments || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanSellerAdjustmentsReducer;
